import { Image } from '@doist/marketist';
import { useTranslation } from 'next-i18next';
import { ProductUISceneContainer } from '../product-ui-scene-container/product-ui-scene-container';
function IntegrationsScene() {
  const {
    t
  } = useTranslation('productui');
  return <ProductUISceneContainer backgroundVariant="wave-two" data-sentry-element="ProductUISceneContainer" data-sentry-component="IntegrationsScene" data-sentry-source-file="integrations.tsx">
            <Image src={`${process.env.NEXT_PUBLIC_BASE_URL}/static/features-teams/scenes/speed-of-thought/todoist-integrations-v2.png`} width={590} height={550} style={{
      zIndex: 1
    }} alt={t('integrationImageAlt')} data-sentry-element="Image" data-sentry-source-file="integrations.tsx" />
        </ProductUISceneContainer>;
}
export { IntegrationsScene };